export const makeId = (...args: string[]) => {
  return args.filter(Boolean).join('-')
}

export const clamp = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max)
}
